import { useI18n } from '@app-velocity/i18n';

import { isActionConfirmationModal } from '../../guards/isActionConfirmationModal';
import { useModalContext, useModalWrapperContext } from '../../../Modal';
import { Button } from '../../../Button';

export const ModalWindowControls = () => {
  const { closeModal } = useModalContext();
  const { modalData } = useModalWrapperContext();
  const { t } = useI18n();

  if (!isActionConfirmationModal(modalData)) {
    return null;
  }

  const handleSuccessClick = () => {
    closeModal(true);
  };

  const handleDenyClick = () => {
    closeModal(false);
  };

  return (
    <>
      <Button
        variant="contained"
        color={modalData['action-confirmation'].confirmButtonColor || 'primary'}
        onClick={handleSuccessClick}
      >
        {t(modalData['action-confirmation'].confirmButtonText)}
      </Button>
      <Button variant="contained" color="secondary" onClick={handleDenyClick}>
        {t(modalData['action-confirmation'].cancelButtonText)}
      </Button>
    </>
  );
};
